export default __webpack_public_path__ + "static/media/servicetype_pd_192.fbd48539.png";